export default "/images/program1.png?e16ea4b54ffa7fb56238b2f5bf52b38a";